export enum InspectorStatusEnum {
  waitingForFormalControl = 'waitingForFormalControl',
  waiting = 'waiting',
  accepted = 'accepted',
  acceptedWithRemarks = 'acceptedWithRemarks',
  rejected = 'rejected',
  timedOut = 'timedOut',
}
